import { StoryWithHistoryState } from 'store/reducers/StoryWithHistoryReducer';
import { storyWithHistorySelector } from 'store/TopLevelSelector';

export const selectors = {
  canRedo: (state: any) => canRedo(storyWithHistorySelector(state)),
  canUndo: (state: any) => canUndo(storyWithHistorySelector(state)),
};

const canUndo = (state: StoryWithHistoryState) => state.past.length > 1;
const canRedo = (state: StoryWithHistoryState) => state.future.length > 0;
